export default {"src":"/_next/static/media/information-box.e0281763.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};